import {Dialog} from "../../util/dialogs.js";
import {EventsEmitter} from "../../events-emitter.js";

export class TakePhotoModal {

    constructor(options = {}) {
        this.events = new EventsEmitter();
        this.barcodeScanner = Boolean(options.barcodeScanner);
    }

    async hasAvailableCameras() {
        return navigator.mediaDevices && (await this.getVideoDevices()).length > 0;
    }

    async getVideoDevices() {
        if (!navigator.mediaDevices) {
            return [];
        }
        const availableDevices = await navigator.mediaDevices.enumerateDevices();
        return availableDevices.filter(device => device.kind === 'videoinput');
    }

    async show() {
        let resolve, reject;
        const promise = new Promise((res , rej) => {
            resolve = res;
            reject = rej;
        });

        if (!navigator.mediaDevices) {
            throw 'Twoja przeglądarka nie obsługuje kamery';
        }

        const modal = new Dialog({
            show: false,
            showHeader: false,
            showFooter: false,
            class: 'media-modal',
        });

        this.modal = modal;

        const video = document.createElement('video');
        const $spinner = jQuery('<div>', {class: 'text-center text-white position-fixed top-50 start-0 w-100'}).append([
            POLKURIER.createSpinner({center: true, color: 'white'}),
            'Proszę o nadanie uprawnień do kamery urządzenia'
        ]);

        this.$captureButton = jQuery('<button>', {type: 'button', class: 'btn'}).append([
            jQuery('<i>', {class: 'bi bi-camera'})
        ]);

        const $switchStreamsButton = jQuery('<button>', {type: 'button', class: 'btn'}).append([
            jQuery('<i>', {class: 'bi bi-arrow-repeat'})
        ]);

        const $cancelButton = jQuery('<button>', {type: 'button', class: 'btn'}).append([
            jQuery('<i>', {class: 'bi bi-x'}),
        ]);

        let $barcodeScannerOverlay;
        if (this.barcodeScanner && window.ZXing) {
            $barcodeScannerOverlay = jQuery('<div>', {class: 'barcode-scanner-overlay'}).append([
                jQuery('<div>', {class: 'barcode-scanner-overlay-label'}).append(['Zeskanuj kod kreskowy lub QR']),
                jQuery('<div>', {class: 'barcode-scanner-overlay-frame-tl'}),
                jQuery('<div>', {class: 'barcode-scanner-overlay-frame-tr'}),
                jQuery('<div>', {class: 'barcode-scanner-overlay-frame-br'}),
                jQuery('<div>', {class: 'barcode-scanner-overlay-frame-bl'}),
            ])
        }

        $cancelButton.on('click', () => {
            modal.hide();
            resolve(null);
        });

        let currentDevice
        let barcodeReader;
        const availableVideoDevices = await this.getVideoDevices();

        const playNextDevice = async () => {
            currentDevice = availableVideoDevices[availableVideoDevices.indexOf(currentDevice) + 1] ?? availableVideoDevices[0];
            if (video.srcObject) {
                for (let track of video.srcObject.getTracks()) {
                    track.stop();
                }
            }
            if (barcodeReader) {
                barcodeReader.stopContinuousDecode();
                barcodeReader = null;
            }
            video.srcObject = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: currentDevice.deviceId,
                    facingMode: 'environment',
                    width: {ideal: 3840},
                    height: {ideal: 2160},
                },
            });

            await video.play();

            if (this.barcodeScanner && window.ZXing) {
                barcodeReader = new ZXing.BrowserMultiFormatReader();
                await barcodeReader.decodeFromStream(video.srcObject, void 0, (result, error) => {
                    if (result) {
                        this.events.emit('barcode:scanned', result);
                    }
                });
            }
        };

        $switchStreamsButton.on('click', async () => {
            return await playNextDevice();
        });

        const $mediaControls = jQuery('<div>', {class: 'media-controls'});
        modal.$content.append([
            $spinner,
            $mediaControls.append([
                $cancelButton,
            ]),
        ]);

        modal.onShown(async () => {
            if (availableVideoDevices.length === 0) {
                modal.hide();
                reject('Nie wykryto kamery');
                return;
            }

            try {
                $mediaControls.prepend([
                    this.$captureButton,
                    availableVideoDevices.length > 1 ? $switchStreamsButton : null,
                ]);
                modal.$content.append([
                    $barcodeScannerOverlay,
                    video
                ]);
                this.events.emit('camera:access');
                await playNextDevice();
                $spinner.remove();
            } catch (e) {
                modal.hide();
                console.error(e);
                reject('Nie można wykonać zdjęcia - brak uprawnień do kamery urządzenia.');
            }
        });

        modal.show();
        this.$captureButton.on('click', () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
            canvas.toBlob((blob) => {
                blob.name = 'obraz_' + Date.now() + '.jpg';
                resolve(blob);
                modal.hide();
            }, 'image/jpeg', 0.9);
        });

        modal.onClose(() => {
            if (barcodeReader) {
                barcodeReader.stopContinuousDecode();
                barcodeReader = null;
            }
            if (video.srcObject) {
                for (let track of video.srcObject.getTracks()) {
                    track.stop();
                }
            }
            video.srcObject = null;
        });

        return await promise;
    }

    hide() {
        if (this.modal) {
            this.modal.hide();
        }
    }

}
